<div class="password-container">
  <div class="password">
    <label for="password">Password</label>
    <input
      type="password"
      id="password"
      [(ngModel)]="password"
      #passwordInput="ngModel"
    />
  </div>
  <div class="password-strength">
    <progress [value]="passwordStrengthPercent" [max]="100"></progress>
  </div>

  <div class="password-hints" *ngIf="passwordInput.touched">
    <ul>
      <li *ngIf="!has8Characters">Min Length of 8 Required</li>
      <li *ngIf="!hasCapitalLetter">One or More Capital Letter Required</li>
      <li *ngIf="!hasNumber">One or More Number Required</li>
      <li *ngIf="!hasSpecialCharacters">
        One or More Special Characters Required
      </li>
    </ul>
  </div>
</div>
